import { render, staticRenderFns } from "./CaseImageFormTWAIN.vue?vue&type=template&id=2e4daf0b&scoped=true&"
import script from "./CaseImageFormTWAIN.vue?vue&type=script&lang=js&"
export * from "./CaseImageFormTWAIN.vue?vue&type=script&lang=js&"
import style0 from "./CaseImageFormTWAIN.vue?vue&type=style&index=0&id=2e4daf0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4daf0b",
  null
  
)

export default component.exports